import * as stylex from "@stylexjs/stylex";
import { createFileRoute, getRouteApi, redirect } from "@tanstack/react-router";
import { pillProps } from "@/components/ui/Button";
import CenteredCard from "@/components/ui/CenteredCard";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";
import { entryTarget } from "@/lib/last-place";
import { trpc } from "@/lib/trpc";

// Bare entry: `/` lands on the person's Last place (see CONTEXT.md). The
// Company layout then picks the remembered section. Anyone without a
// Company sees the empty state below.
export const Route = createFileRoute("/_authenticated/")({
  loader: async ({
    context
  }) => {
    const viewer = await context.queryClient.ensureQueryData(trpc.organization.viewer.queryOptions());
    const target = entryTarget(viewer);
    if (target) throw redirect({
      ...target,
      replace: true
    });
    return null;
  },
  component: EmptyWorkspace
});
const styles = {
  card: {
    kGNEyG: "x6s0dn4",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  action: {
    keoZOQ: "x11j7w4t",
    $$css: true
  }
};
const authenticatedRoute = getRouteApi("/_authenticated");
function EmptyWorkspace() {
  const viewer = authenticatedRoute.useLoaderData();
  return <CenteredCard xstyle={styles.card}>
      <h1 className="x1ghz6dp xuxpmqx xk50ysn xgwkh9f">No Company access</h1>
      <p className="x1ghz6dp xtu3avg x1evy7pa x1e3avs9">Ask an admin to invite you to a Company.</p>
      {viewer?.email && <p className="x1ghz6dp x7x6yu3 x1i6qc9y">Signed in as {viewer.email}</p>}
      <a href="mailto:marketing@askeladden.co" {...pillProps({
      variant: "primary",
      xstyle: styles.action
    })}>
        Contact A&amp;CO
      </a>
    </CenteredCard>;
}